module.exports = __webpack_public_path__ + "static/media/assurancemezz.41313b45.png";